/* eslint-disable @typescript-eslint/no-explicit-any */ import { currencyValueFormatter, interpolateI18n } from "@cinch-labs/shared-util";
export const getActiveCtaText = (template, budget)=>interpolateI18n(template, {
        budget: currencyValueFormatter(budget)
    }).join("");
export const getFiltredUrl = (baseCtaUrl, toPrice, useMonthly)=>{
    const parameters = {
        toPrice,
        useMonthly,
        sortingCriteria: useMonthly ? 12 : 10
    };
    return `${baseCtaUrl}?${Object.entries(parameters).map(([key, value])=>`${key}=${value}`).join("&")}`;
};
export const convertToPence = (value)=>{
    if (typeof value === "undefined") return;
    if (value === "0") {
        return value;
    }
    const onlyNums = Math.round(Number.parseFloat(value.replace(/[^\d.?]/g, "")));
    if (Number.isNaN(onlyNums)) {
        return "";
    }
    return onlyNums * 100;
};
export const formatToPounds = (value)=>{
    if (typeof value === "undefined" || typeof value === "string" && Number.isNaN(Number.parseFloat(value))) {
        return "";
    }
    if (typeof value === "number") {
        return formatPenceToPounds(value);
    }
    return formatPenceToPounds(Number.parseFloat(value));
};
const formatPenceToPounds = (value)=>`£${Math.ceil(value / 100)}`;
